import React, { useEffect } from "react";
import Title from "../../new-components/title/Title";
import { Link, useLocation, useParams } from "react-router-dom";
import Overllay from "../../assets/new_imgs/Rectangle 1072.png";
import NewFooter from "../../NewFooter";
import "./FoodAndBeverages.scss";

const FoodAndBeverages = () => {
  const params = useParams();
  const lang = localStorage.getItem("lang");
  const location = useLocation();
  const metadata = location.state?.metadata;
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
    });
  }, []);

  return (
    <div className={`food pb-5 ${lang === "AR" && "arabic"}`}>
      <Title title={"Food & Beverages"} />
      {/* <NewLoader /> */}

      <div className="box_food image_services">
        {metadata?.map((service) => {
          if (service.id === 8) {
            return (
              <Link
                to={`/${params.room_uuid}/food-and-beverages/in-room-dining`}
                key={service.id}
              >
                <img
                  src={
                    "https://d3l5wxnahfuscp.cloudfront.net/static/Dining.png"
                  }
                  alt=""
                  className="service_img"
                />
                <img src={Overllay} alt="" className="overlay" />
                <h6 className="sub_title">{service?.display_name}</h6>
              </Link>
            );
          }
          if (service.id === 1) {
            return (
              <Link
                to={`/${params.room_uuid}/food-and-beverages/in-room-dining`}
              >
                <img
                  src={
                    "https://d3l5wxnahfuscp.cloudfront.net/static/Dining.png"
                  }
                  alt=""
                  className="service_img"
                />
                <img src={Overllay} alt="" className="overlay" />
                <h6 className="sub_title">{service?.display_name}</h6>
              </Link>
            );
          }
          if (service.id === 2) {
            return (
              <Link
                to={`/${params.room_uuid}/food-and-beverages/restaurant-booking`}
              >
                <img
                  src={
                    "https://d3l5wxnahfuscp.cloudfront.net/static/booking.png"
                  }
                  alt=""
                  className="service_img"
                />
                <img src={Overllay} alt="" className="overlay" />
                <h6 className="sub_title">{service?.display_name}</h6>
              </Link>
            );
          }
        })}
      </div>
      <NewFooter />
    </div>
  );
};

export default FoodAndBeverages;
